<template>
  <section>
    <div>
      <div class="second-image">
        <div class="electric-bike-container">
          <div class="wrapper">
            <div class="intro-container">
              <h1 class="header">About Pedalsure</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="container about-us-container">
        <div class="columns">
          <div class="column">
            <h2>We’re dedicated to helping cyclists ride smarter</h2>
            <div>
              Since 2014, at Pedalsure we’ve been working harder than a Tour de
              France pro to provide the best cycling insurance for the most
              competitive price.
              <br />
              <br />
              That means comprehensive cover designed specifically for cyclists:
              from theft and accidental damage, to personal liability, overseas
              cover and much more.
            </div>
          </div>
          <div class="column is-flex is-vcentered">
            <img
              src="~/assets/images/about/Pedalsure Innovation Machine.svg"
              class=""
              alt="Pedalsure Innovation Machine icon"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column is-flex is-vcentered">
            <img
              src="~/assets/images/about/Policy.svg"
              class=""
              alt="Pedalsure Innovation Machine icon"
            />
          </div>
          <div class="column">
            <h2>Cycling insurance: it’s all we do</h2>
            <div>
              We know you want to be out on the bike as much as possible and
              dealing with insurance is probably the last thing anyone wants to
              do. That’s where we come in.
              <br />
              <br />
              <br />
              We’re dedicated to cycling insurance. In fact, it’s all we do.
              This focus means we’re able to deliver the best value, most
              comprehensive cover and provide quick customer service that you
              can rely on.
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <h2>Why trust Pedalsure</h2>
            <div>
              We’re a group of insurance specialists who put the customer at the
              centre of everything we do. Many of us are keen cyclists too.

              <br />
              <br />
              From enquiries and purchase, to policy support and claims, we
              strive to offer the very best customer experience of any cycling
              insurer. And it shows - we’re rated {{ ratingLabel }} –
              {{ ratingValue }} out of 5.
            </div>
          </div>
          <div class="column is-flex is-vcentered">
            <img
              src="~/assets/images/about/Trust.svg"
              class=""
              style="max-width: 400px"
              alt="Pedalsure Innovation Machine icon"
            />
          </div>
        </div>
        <div class="our-story-container">
          <h2 class="has-text-centered">Our story so far</h2>
          <div class="is-flex is-justify-content-space-between">
            <div
              class="is-flex is-flex-direction-column is-justify-content-center"
            >
              <img
                src="~/assets/images/about/public-liability (1).svg"
                class="our-story-img"
                alt="Pedalsure Innovation Machine icon"
              />

              <div class="our-story-text">
                More than 50,000 cyclists covered
              </div>
            </div>
            <div
              class="is-flex is-flex-direction-column is-justify-content-center"
            >
              <div class="our-story-text">Rated Excellent by thousands</div>
            </div>
            <div
              class="is-flex is-flex-direction-column is-justify-content-center"
            >
              <img
                src="~/assets/images/about/payment-promise (1).svg"
                class="our-story-img"
                alt="Pedalsure Innovation Machine icon"
              />

              <div class="our-story-text">
                Over £110 million of bikes protected
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { RATING_LABEL, RATING_VALUE } from '@/helpers/rating'

export default {
  name: 'AboutUsPage',
  data() {
    return {
      ratingLabel: RATING_LABEL,
      ratingValue: RATING_VALUE,
    }
  },
  head() {
    const title = 'About Pedalsure: Cycling Insurance Specialists Since 2014'
    const description =
      'Pedalsure is a specialist UK cycling insurer. We’re dedicated to cycling insurance and we’ve been trusted by thousands since 2014.'
    const keywords = 'bicycle insurance companies'
    return {
      title,
      meta: [
        { hid: 'description', name: 'description', content: description },
        { hid: 'keywords', name: 'keywords', content: keywords },
        {
          hid: 'twitter:card',
          name: 'twitter:card',
          content: 'About Pedalsure: Cycling Insurance Specialists Since 2014',
        },
        { hid: 'twitter:title', name: 'twitter:title', content: title },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: description,
        },
        { hid: 'og:title', property: 'og:title', content: title },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description,
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.about-us-container {
  max-width: 500px;
  margin: 0 auto;
  padding: 0 20px;
  @include tablet {
    max-width: 700px;
  }
  @include desktop {
    max-width: 800px;
  }
}

.wrapper {
  margin: 0 auto;
  max-width: 500px;
}

.intro-container {
  padding: 0 15px;
  min-height: 150px;
  @include tablet {
    padding: 0;
    min-height: 300px;
  }
  .header {
    font-size: 9vw;
    line-height: 10vw;
    max-width: 500px;
    text-align: center;
    color: $ps-primary;
    margin: 60px auto 20px;
    @include tablet {
      font-size: 5.5vw;
      line-height: 6vw;
    }
    @include desktop {
      padding: 85px 0;
      font-size: 4vw;
      line-height: 5vw;
    }
  }

  .image {
    max-width: 36%;
  }
}
.electric-bike-container {
  position: relative;
  padding-bottom: 80px;

  &:before,
  &:after {
    content: '';
    position: absolute;
    height: 100%;
    width: 50%;
    bottom: 0;
    top: 0;
    z-index: -2;
    background-repeat: no-repeat;
    background-size: 170%;
    background-position-y: bottom !important;

    @include tablet {
      background-size: 140%;
    }
    @include desktop {
      background-size: 100%;
    }
  }
  &:before {
    background-image: url('~assets/images/about/Left-header-about-page.svg');
    left: 0;
    background-position: -150px;
    @include desktop {
      background-position: -130px;
    }
  }
  &:after {
    background-image: url('~assets/images/about/Right-header-about-page.svg');
    right: 0;
    background-position: 20px;
  }
}
h2 {
  color: $ps-primary;
  font-size: 30px;
  line-height: 30px;
  margin: 20px 0;
  @include tablet {
    font-size: 35px;
    line-height: 45px;
    margin: 30px 0;
  }
}
.is-vcentered {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.our-story-container {
  max-width: 700px;
  margin: 0 auto 60px;
}
.our-story-img {
  max-height: 70px;
}
.our-story-text {
  text-align: center;
  font-size: 13px;
  max-width: 150px;
  margin-top: 10px;
  @include tablet {
    font-size: 15px;
  }
}
</style>
